import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AllBillingEntityDto, GetAllCompanyDto } from "@/types/api/api-types";
import { Modal } from "@/components/ui/customs/modal";
import { PaymentMethodElem } from "./paymentMethodElem";
import { PaymentMethodeEditModal } from "./paymentMethodeEditModal";

interface ListEditModalProps {
  closeModal: () => void;
  company: GetAllCompanyDto;
}

export const ListEditModal = ({ closeModal, company }: ListEditModalProps) => {
  const { t } = useTranslation("boClients");
  const [selectedBillingEntity, setSelectedBillingEntity] = useState<AllBillingEntityDto>();

  if (selectedBillingEntity) {
    return (
      <PaymentMethodeEditModal
        billingEntity={selectedBillingEntity}
        closeModal={() => setSelectedBillingEntity(undefined)}
      />
    );
  }

  return (
    <Modal
      open={true}
      onClose={closeModal}
      title={t("profilePaymentListEditModal.title")}
      size="md"
      dismissible
    >
      <div className="flex w-full flex-col gap-4">
        <h3 className="text-brand700 text-base font-semibold">
          {t("profilePaymentListEditModal.subtitle")}
        </h3>
        {company.billingEntities.map((billingEntity, index) => (
          <PaymentMethodElem
            key={index}
            isDefault={billingEntity.isDefault}
            name={billingEntity.companyName}
            mode={billingEntity.paymentMethod}
            onClick={() => setSelectedBillingEntity(billingEntity)}
          />
        ))}
      </div>
    </Modal>
  );
};
